import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getToUrl, translateData } from 'utils/translation';
import { Button, H1, H6, Span, Img } from 'components/Ui';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { QuickShopImageNew, ShopImageGeneric } from 'images';
import withContentful from 'containers/Landing/withContenfull';
import { getDomainByHost } from 'utils/domainHelper';
import { pages } from 'containers/Landing/constants';
import styles from './styles.scss';

const WaterStartOrder = () => {
  const handleSignInClick = () => {
    const { brand } = getDomainByHost(35);
    window.location.href = `https://drink.${brand}.com`;
  };

  const quickShopLink = '/quick-shop/select-water';
  const shopLink = '/bottled-water-and-coffee';

  return (
    <ValidatorForm className={styles.container}>
      <Helmet title={translateData('Start Order')} />
      <H1>Let’s get started</H1>
      <div>
        <Span>Already have an account?</Span>
        <Button
          link
          className={styles.signIn}
          onClick={handleSignInClick}
          text="Sign In"
        />
      </div>
      <div className={styles.formContainer}>
        <div className={styles.content}>
          <H6>Two ways to shop:</H6>
          <div className={styles.shopContainer}>
            <div className={styles.shopItem}>
              <Img src={QuickShopImageNew} alt="Quick shop" />
              <H6>Quick shop</H6>
              <Span>
                If you know you’d like, either 3- or 5- gallon bottles and a
                cooler, we’ll get you through your order fast.
              </Span>
              <Button text="Quick Shop" href={`${quickShopLink}/`}>
                <Link to={getToUrl(quickShopLink, 'U53')}></Link>
              </Button>
            </div>
            <div className={styles.shopItem}>
              <Img src={ShopImageGeneric} alt="Shop all products" />
              <H6>Shop all products</H6>
              <Span>
                Select from our full variety of products from large bottles, to
                sparking, to case packs, coffee, and more.
              </Span>
              <Button text="Shop" href={`${shopLink}/`}>
                <Link to={getToUrl(shopLink, 'U54')}></Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </ValidatorForm>
  );
};

export default withContentful(pages.WaterStartOrder)(WaterStartOrder);
